import React, {useState, useEffect} from 'react'
// import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link';
import CircularProgress from '@material-ui/core/CircularProgress'

import Button from '@material-ui/core/Button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import Api, { handleError } from 'utils/Api'
import useFlash from 'modules/useFlash'
import {WrapForm, PaperPadding} from 'components/molecules/Wrap'
import Helper from 'components/atoms/Helper'

import Form from './parts/Form'
import InfoTemplate from 'components/pages/Defs/parts/Information'
import InfoAsset from './parts/Information'

import useUpdater from 'modules/useUpdater'

export default (props) => {
  const def_id = props.match.params.def_id
  const id = props.match.params.id
  const {handleApiError} = useFlash()
  const [loading, setLoading] = useState(true)
  const [subject, setSubject] = useState()
  const [lastUpdatedAt, update] = useUpdater()

  useEffect(()=>{
    setLoading(true)
    
    const api1 = Api.fetchAuth(`/defs/${def_id}/resources/${id}`).then(r=>r.json())

    Promise.all([api1]).then(responses=>{
      setSubject(responses[0].data)
      setLoading(false)
    }).catch(error=>{
      // setLoading(false)
      handleApiError(error)
    })

  }, [lastUpdatedAt])

  const save = (body) => {
    // console.log('body', body)
    return Api.fetchAuth(`/defs/${def_id}/resources/${id}`, {
      method: 'PUT',
      body: body
    }).then(r=>r.json()).then(response=>{
      update()
      return Promise.resolve()
    }).catch((error)=>{
      handleApiError(error)
      return Promise.resolve()
    })
  }

  if (loading) return <CircularProgress />

  return (
    <>
      <PaperPadding>
        <Grid container spacing={2} direction="row" alignItems="center">
          <Grid item>
            <Link href={`/defs/${subject.definition.id}`}>リソース定義を変更</Link>
          </Grid>
          <Grid item>
            <Link href={`/defs/${subject.definition.id}/resources`}>リソース一覧</Link>
          </Grid>
        </Grid>
      </PaperPadding>
      <WrapForm>
        <Typography variant="h6" gutterBottom>リソース {subject.definition.slug}</Typography>
        <Form {...{save, subject, definition: subject.definition}} />
      </WrapForm>
    </>
  )
}
